/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import Button from '../elements/Button';
import logo from '../assets/images/CompanyLogo.png'; // Update path based on your actual directory

export default function BrandIcon() {
  return (
    <Button
      className=""
      type="link"
      href="/"
    >
      <div className="flex flex-row items-center">
        <img src={logo} alt="MS Contractors Logo" className="w-20 h-17 mb-1" /> {/* Adjust size as needed */}
        <p className="text-theme-black text-2xl font-medium ">
          MS
          <span className="text-theme-black"> Contractors</span>
        </p>
      </div>
    </Button>
  );
}
